import React, { useState } from 'react';
import DepartmentForm from './DepartmentForm';
import AdminTimeslotManager from './AdminTimeslotManager';
import AdminSignupView from './AdminSignupView';
import AdminHoursView from './AdminHoursView';
import HoursReport from './HoursReport';
import DepartmentAdminView from './DepartmentAdminView';

function AdminDashboard({ username, role, departmentId, onLogout }) {
  const [activeTab, setActiveTab] = useState('signups');

  if (role === 'dept_admin') {
    return <DepartmentAdminView departmentId={departmentId} username={username} onLogout={onLogout} />;
  }

  return (
    <div className="admin-container">

      {/* 🟠 LCARS HEADER */}
      <div className="admin-header">
        
        <div className="admin-title-section">
          <h1>Admin Dashboard</h1>
          <p className="admin-user">
            Logged in as: <strong>{username}</strong>
          </p>
        </div>

        {/* 🔴 MOVE LOGOUT HERE */}
        <button className="logout-btn" onClick={onLogout}>
          Logout
        </button>

      </div>

      {/* 🟣 NAV TABS */}
      <nav className="admin-nav">
        <button 
          className={activeTab === 'signups' ? 'active' : ''}
          onClick={() => setActiveTab('signups')}
        >
          Volunteer Signups
        </button>
        
        <button 
          className={activeTab === 'timeslots' ? 'active' : ''}
          onClick={() => setActiveTab('timeslots')}
        >
          Time Slots
        </button>

        <button 
          className={activeTab === 'departments' ? 'active' : ''}
          onClick={() => setActiveTab('departments')}
        >
          Departments
        </button>

        <button
          className={activeTab === 'hours' ? 'active' : ''}
          onClick={() => setActiveTab('hours')}
        >
          Hours
        </button>

        <button
          className={activeTab === 'report' ? 'active' : ''}
          onClick={() => setActiveTab('report')}
        >
          Reports
        </button>
      </nav>

      {/* CONTENT */}
      <main className="admin-content">
        {activeTab === 'signups' && <AdminSignupView username={username} />}
        {activeTab === 'timeslots' && <AdminTimeslotManager />}
        {activeTab === 'departments' && <DepartmentForm />}
        {activeTab === 'hours' && <AdminHoursView />}
        {activeTab === 'report' && <HoursReport />}
      </main>
    </div>
  );
}

export default AdminDashboard;


